import { cn } from "../../../../../../utils/cn";
import { ReceiptItemStateEnum } from "../../../../../../utils/enums";
import { INVERTED_SECTIONS } from "../../../../../../utils/types";
import { PLink } from "../../../../../global/PLink";
import { DeliveryReceiptStateV2 } from "../../../../S-Pay/ReceiptState/DeliveryReceiptStateV2";
import { ReceiptStateV2 } from "../../../../S-Pay/ReceiptState/ReceiptStateV2";
import card from "../../OrderCardV2.module.scss";
import { OrderRateRow } from "../../OrderRateRow";
import { getReceiptSourceTranslationKey } from "../../PreviousOrdersHelper";
import { UseCurrentOrderProps, useCurrentOrder } from "../useCurrentOrder";
import styles from "./CurrentOrderV2.module.scss";

export const CurrentOrderV2 = (props: UseCurrentOrderProps) => {
  const {
    t,
    receipt,
    trackYourOrder,
    yourCurrentOrder,
    order,
    getTimeInHours,
    openFeedbackModal,
    hasFeedback,
    restaurantInfo,
    bottomSheetModal,
    payPageLink,
    orderTypeTranslationKey,
    formattedTime,
  } = useCurrentOrder(props);

  if (!receipt || receipt.state === ReceiptItemStateEnum.COMPLETED) {
    return null;
  }

  return (
    <div className={card.card_container} data-testid={"current-order"}>
      <div className={card.card_head}>
        <div className={card.card_head_content}>
          <div className={card.card_head_content_top}>
            <p className={card.card_title}>
              {yourCurrentOrder} {getTimeInHours()}
            </p>
            <div className={card.card_head_buttons} />
          </div>
          <div className={card.card_head_content_bottom}>
            <span className={card.head_bottom_item}>{formattedTime}</span>
            <span className={card.head_bottom_item}>
              {t(orderTypeTranslationKey)}
            </span>
            <span className={card.head_bottom_item}>
              {t(getReceiptSourceTranslationKey(receipt))}
            </span>
          </div>
        </div>
      </div>
      <div
        className={cn(
          card.main_content,
          restaurantInfo?.colors?.invertedSections?.includes(
            INVERTED_SECTIONS.CURRENT_ORDER
          ) && "invert"
        )}
      >
        <div className={card.order_id_section}>
          <div className={card.order_id_row}>
            <span data-testid="current-order-id">
              {order}: #{receipt.displayedReceiptId}
            </span>
          </div>
          <div className={styles.see_more}>
            {restaurantInfo && !bottomSheetModal.isOpen && (
              <PLink link={payPageLink}>
                <a
                  data-testid={"current-order-seemore"}
                  className={styles.see_more_link}
                >
                  {trackYourOrder}
                </a>
              </PLink>
            )}
          </div>
        </div>
        <div
          className={cn(
            card.card_body,
            styles.card_body_state
            // restaurantInfo?.colors?.invertedSections?.includes(
            //   INVERTED_SECTIONS.CURRENT_ORDER
            // ) && "invert"
          )}
        >
          {receipt.receiptExtras?.isRoboostReceipt ? (
            <DeliveryReceiptStateV2 isOrdersTab receipt={receipt} />
          ) : (
            <ReceiptStateV2 isOrdersTab receipt={receipt} />
          )}
        </div>
        <OrderRateRow
          orderId={receipt.id}
          hasFeedback={hasFeedback}
          openFeedbackModal={openFeedbackModal}
          firstStarTestId="current-order-rate"
        />
      </div>
    </div>
  );
};
